import React, { Fragment } from "react";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import { getSupportingDocuments } from "../AirBrakeReports/AirBrakeReports/CommonFunctions";

export const MainReservoirReport = (props) => {
  const { reportData } = props;

  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  // let removeDuplicates = ReportGroupingUtils.RemoveDuplicateTestCodesFromGroupedReport(reportsByDateAndUser);
  let decodedReports = ReportGroupingUtils.decodeTestsInReportGroups(reportsByDateAndUser);

  return (
    <React.Fragment>
      {decodedReports.map((report, i) => {
        return (
          <div key={i} className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
            <ReportView key={i} data={report} {...props} />
          </div>
        );
      })}
    </React.Fragment>
  );
};

const ReportView = (props) => {
  const { data, title } = props;
  const { decodedData, fraHeaderInfo } = data;
  return (
    <Fragment>
      {decodedData.map((singleReport, index) => (
        <div index={index}>
          <ReportTitleSection title={title} fontSizeOverride={"35px"} />
          <ReportFraInfoSectionContainer {...props} />
          <span className="spacer"></span>
          <table className="table-bordered">
            <ReportTableSectionRenderer
              rowsData={singleReport.summary}
              section={{
                heights: { header1: "40px" },
                classes: { header2: "" },
                inlineData: true,
                columns: [
                  {
                    title: "H&H Test Pressure",
                    colSpan: 5,
                    rowSpan: 1,
                    topAlign: true,
                    leftAlign: true,
                    className: "tbl-text-normal",
                    accessor: "",
                    isTitleOnly: true,
                  },
                  {
                    title: "H&H Test Pressure",
                    colSpan: 1,
                    rowSpan: 1,
                    topAlign: true,
                    leftAlign: true,
                    className: "tbl-text-normal",
                    accessor: "testPressurePsi",
                    isValueOnly: true,
                    formatter: (vals) => {
                      return <span>{vals} PSI</span>;
                    },
                  },
                ],
              }}
            />
          </table>
          {Object.keys(singleReport.summary).includes("supportingDocuments") && getSupportingDocuments(singleReport.summary)}
        </div>
      ))}
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/MainReservoirTest/MainReservoirTest.jsx